import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import NavLogo from "../../assets/images/logo/B-T-HTMATE.svg";
import ExampleLogo from "../../assets/images/logo/logo 1.png";
import HomeIcon from "@mui/icons-material/Home";
import HistoryIcon from "@mui/icons-material/History";
import EventIcon from "@mui/icons-material/Event";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { useHistory } from "react-router-dom";
import { BrandingContext } from "../../BrandingProvider";
import axios from "axios";

import UserPool from "../../pages/login/UserPool";

import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";

import { fetchOrgCodeAndValidate } from "../../pages/login/indexedDBHelper";
import { usePermissions } from "../../pages/login/PermissionContext";
import showConfirmDialog from "../ShowConfirmDialog/ShowConfirmDialog";
import DigitalClockTime from "../../pages/doctor-console/DigitalClock/DigitalClockTime";
import ProfileDropdown from "../ProfileDropdown/ProfileDropdown";
import NavbarPatientSearch from "../PatientSearch/NavbarPatientSearch";
import { usePatientContext } from "../../context/PatientContext";
import QuickRegisterPatientModal from "../QuickRegisterPatient/QuickRegisterPatientModal";

function Navbar() {
  const history = useHistory();
  const { clearPatient } = usePatientContext();
  const [orgCode, setOrgCode] = useState("");
  const [openRegisterPatient, setOpenRegisterPatient] = useState(false);
  const roleType = sessionStorage.getItem("roleType");
  const refreshToken = sessionStorage.getItem("refreshToken");
  const accessToken = sessionStorage.getItem("accessToken");
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const authToken = sessionStorage.getItem("accessToken") ?? "";
  const { permissions = [] } = usePermissions();
  const headers = useMemo(
    () => ({ Authorization: `Bearer ${authToken}` }),
    [authToken],
  );
  const normalize = (str = "") => str.toLowerCase().replace(/[^a-z0-9]/g, "_");
  const allowedIds = useMemo(
    () =>
      new Set(
        permissions
          .filter((p) => p.is_accessible)
          .map((p) => normalize(p.permission_name)),
      ),
    [permissions],
  );
  const canManageAppointments = allowedIds.has(
    normalize("manage appointments"),
  );
  const canViewHistoricalRecords = allowedIds.has(normalize("manage patients"));
  const canSearchPatients = canViewHistoricalRecords;

  const handleNavigation = (id) => {
    history.push(`/${id}`);
  };
  const brandingData = useContext(BrandingContext);
  const [isEmergencyPopupOpen, setIsEmergencyPopupOpen] = useState(false);
  const emergencyPopupRef = useRef(null);
  const isAdminRole = () => {
    const adminRoles = [
      "facility admin",
      "customer admin",
      "partner admin",
      "admin",
    ];
    return adminRoles.includes(roleType);
  };

  console.log("orgCode", orgCode);
  const isUser = () => {
    const userRoles = ["facility user", "user", "lab user", "pharmacy user"];
    return userRoles.includes(roleType);
  };
  const isDoctor = () => {
    const DoctorRole = ["doctor"];
    return DoctorRole.includes(roleType);
  };
  // const isSuperAdmin = userInfo?.role_permission?.[0]?.role === "super admin";
  // const canAccessAppointments =
  //   isSuperAdmin ||
  //   permissions.some(
  //     (permission) =>
  //       permission.permission_name === "manage appointments" &&
  //       permission.is_accessible,
  //   );

  const handleHomeClick = () => {
    // if (isAdminRole()) {
    //   history.push("/hlthtek-admin-demo");
    // } else if (isUser()) {
    //   history.push("/hlthtek-demo");
    // } else if (isDoctor()) {
    //   history.push("/doctor/landing");
    // } else {
    //   history.push("/login");
    // }
    history.push("/main-landing");
  };

  const Logout = () => {
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}logout/`,
        {
          refresh_token: refreshToken,
        },
        { headers },
      )
      .then((res) => {
        // console.log(res.status);
        clearPatient();
        sessionStorage.clear();
        // window.location.reload();
        history.push("/login");

        const user = UserPool.getCurrentUser(); // Get the current Cognito user
        if (user) {
          user.signOut(); // Sign out the user from Cognito
          console.log("User signed out from Cognito");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    // setLoading(true);
    console.log("useEffect");
    fetchOrgCodeAndValidate((data) => {
      console.log("inside fetchOrgCodeAndValidate", data);
      if (data) {
        const { org_code } = data;
        setOrgCode(org_code);
      } else {
        console.error("Failed to fetch data from IndexedDB.");
        // setLoading(false);
      }
    });
  }, [accessToken]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        emergencyPopupRef.current &&
        !emergencyPopupRef.current.contains(event.target)
      ) {
        setIsEmergencyPopupOpen(false);
      }
    };

    if (isEmergencyPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isEmergencyPopupOpen]);
  return (
    <div>
      <header className="header header-layout1" style={{ zoom: "0.85" }}>
        <div
          className="header-topbar"
          style={{
            backgroundColor: "#1d2a4d",
          }}
        >
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-12">
                {/* <Grid
                  container
                  alignItems="center"
                  justifyContent="space-between"
                  spacing={2}
                >
                  
                  <Grid item>
                    <Grid container alignItems="center" spacing={2}>
                      <Grid item>
                        <Button
                          className="miniPopup-emergency-trigger"
                          variant="contained"
                          sx={{ textTransform: "none" }}
                        >
                          24/7 Healthcare
                        </Button>
                        <Box
                          id="miniPopup-emergency"
                          className="miniPopup miniPopup-emergency text-center"
                          sx={{
                            minWidth: "360px",
                            padding: "1rem",
                            mt: 1,
                          }}
                        >
                          <iframe
                            allow="microphone;"
                            frameBorder="0"
                            width="100%"
                            height="430"
                            style={{ borderRadius: "1rem" }}
                            src="https://console.dialogflow.com/api-client/demo/embedded/6e125afd-59db-43b8-94f1-b470459c0ebe"
                          ></iframe>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>

                  
                  <Grid item>
                    <Grid container alignItems="center" wrap="nowrap">
                      <Grid item>
                        <i className="icon-phone"></i>{" "}
                        <a href="tel:+919073940606">+91-9073940606</a>
                      </Grid>

                      <Divider
                        orientation="vertical"
                        flexItem
                        sx={{
                          height: "24px", // Set fixed height
                          backgroundColor: "#edf1f3ff",
                          mx: 2, // margin left and right
                        }}
                      />

                      <Grid item>
                        <i className="icon-email"></i>{" "}
                        <a href="mailto:contactus@hlthtek.com">
                          contactus@hlthtek.com
                        </a>
                      </Grid>

                      <Divider
                        orientation="vertical"
                        flexItem
                        sx={{
                          height: "24px", // Set fixed height
                          backgroundColor: "#edf1f3ff",
                          mx: 2,
                        }}
                      />

                      <Grid item>
                        <a
                          href="/contact"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Contact Us
                        </a>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid> */}
                {/* <div className="d-flex align-items-center justify-content-between">
                  <ul className="contact__list d-flex flex-wrap align-items-center list-unstyled mb-0">
                    <li>
                      <button
                        className="miniPopup-emergency-trigger"
                        type="button"
                      >
                        24/7 Healthcare
                      </button>
                      <div
                        id="miniPopup-emergency"
                        className="miniPopup miniPopup-emergency text-center"
                        style={{ minWidth: "360px", padding: "1rem" }}
                      >
                        <iframe
                          allow="microphone;"
                          frameBorder="0"
                          width="100%"
                          height="430"
                          style={{ borderRadius: "1rem !important" }}
                          src="https://console.dialogflow.com/api-client/demo/embedded/6e125afd-59db-43b8-94f1-b470459c0ebe"
                        ></iframe>
                      </div>
                    </li>
                  </ul>

                  <ul className="d-flex list-unstyled mb-0 ">
                    <li>
                      <i className="icon-phone"></i>{" "}
                      <a href="tel:+919073940606">+91-9073940606</a>
                    </li>
                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={{
                        backgroundColor: "#edf1f3ff",
                        marginLeft: 1,
                        marginRight: 1,
                        width: "1px",
                        borderRadius: "2px",
                      }}
                    />
                    <li>
                      <i className="icon-email"></i>{" "}
                      <a href="mailto:contactus@hlthtek.com">
                        contactus@hlthtek.com
                      </a>
                    </li>
                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={{
                        backgroundColor: "#edf1f3ff",
                        marginLeft: 1,
                        marginRight: 1,
                        width: "1px",
                        borderRadius: "2px",
                      }}
                    />
                    <li>
                      <a
                        href="/contact"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Contact Us
                      </a>
                    </li>
                  </ul>
                </div> */}

                <div
                  style={{
                    backgroundColor: "#1d2a4d",
                    padding: "8px 16px",
                  }}
                >
                  <Grid container alignItems="center">
                    {/* Left - 24/7 Healthcare */}
                    <Grid item xs={12} sm={2}>
                      <div
                        ref={emergencyPopupRef}
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <Button
                          className="miniPopup-emergency-trigger"
                          type="button"
                          // onClick={() =>
                          //   setIsEmergencyPopupOpen((prevOpen) => !prevOpen)
                          // }
                          sx={{
                            backgroundColor: "#fff",
                            color: "#000",
                            borderRadius: isSmallScreen
                              ? "6px 6px 0 0"
                              : "8px 8px 0 0",
                            padding: isSmallScreen ? "4px 10px" : "6px 14px",
                            fontWeight: isSmallScreen ? 600 : "bold",
                            fontSize: isSmallScreen ? "12px" : "14px",
                            lineHeight: 1.2,
                            textTransform: "none",
                            "&:hover": { backgroundColor: "#f5f5f5" },
                          }}
                        >
                          24/7 Healthcare Service
                        </Button>
                        <div
                          id="miniPopup-emergency"
                          className={`miniPopup miniPopup-emergency text-center ${
                            isEmergencyPopupOpen ? "active" : ""
                          }`}
                          style={{
                            minWidth: isSmallScreen ? "240px" : "360px",
                            maxWidth: isSmallScreen ? "90vw" : "420px",
                            width: "100%",
                            padding: isSmallScreen ? "0.5rem" : "1rem",
                          }}
                        >
                          <iframe
                            allow="microphone;"
                            frameBorder="0"
                            width="100%"
                            height={isSmallScreen ? 360 : 430}
                            style={{ borderRadius: "1rem" }}
                            src="https://console.dialogflow.com/api-client/demo/embedded/6e125afd-59db-43b8-94f1-b470459c0ebe"
                          ></iframe>
                        </div>
                      </div>
                    </Grid>

                    {/* Center - Patient search */}
                    <Grid item xs={12} sm={5}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          gap: 4,
                        }}
                      >
                        {accessToken && canSearchPatients && (
                          <NavbarPatientSearch />
                        )}
                        {/* <Typography
                          variant="body1"
                          sx={{
                            color: "#fff",
                            cursor: "pointer",
                            "&:hover": { textDecoration: "underline" },
                          }}
                        >
                          Find a Doctor
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            color: "#fff",
                            cursor: "pointer",
                            "&:hover": { textDecoration: "underline" },
                          }}
                        >
                          Video Consulting
                        </Typography> */}
                      </Box>
                    </Grid>

                    {/* Right - Icons */}
                    <Grid item xs={12} sm={5}>
                      {accessToken && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: 2,
                            color: "#fff",
                          }}
                        >
                          <Typography
                            variant="body2"
                            component="div"
                            sx={{ cursor: "pointer" }}
                          >
                            <DigitalClockTime />
                          </Typography>
                          {/* <IconButton sx={{ color: "#fff" }}>
                          <SearchIcon />
                        </IconButton> */}
                          <Divider
                            orientation="vertical"
                            flexItem
                            sx={{
                              backgroundColor: "#ffffff66",
                              mx: 1,

                              height: 40,
                            }}
                          />
                          {canViewHistoricalRecords && (
                            <Tooltip title="Quick Patient Registration" arrow>
                              <IconButton
                                onClick={() => setOpenRegisterPatient(true)}
                                sx={{ color: "#fff" }}
                              >
                                <PersonAddAlt1Icon />
                              </IconButton>
                            </Tooltip>
                          )}

                          {canManageAppointments && (
                            <Tooltip title="Appointment Management" arrow>
                              <IconButton
                                onClick={() =>
                                  history.push("/doctor/appointments")
                                }
                                sx={{ color: "#fff" }}
                              >
                                <EventIcon />
                              </IconButton>
                            </Tooltip>
                          )}

                          {canViewHistoricalRecords && (
                            <Tooltip title="Patient Historical Records" arrow>
                              <IconButton
                                onClick={() =>
                                  history.push("/patient-local-data")
                                }
                                sx={{ color: "#fff" }}
                              >
                                <HistoryIcon />
                              </IconButton>
                            </Tooltip>
                          )}

                          <IconButton
                            onClick={handleHomeClick}
                            sx={{ color: "#fff" }}
                          >
                            <HomeIcon />
                          </IconButton>
                          <ProfileDropdown onLogout={Logout} />
                        </Box>
                      )}
                    </Grid>
                  </Grid>
                </div>
              </div>
            </div>
            {/* <!-- /.row  --> */}
          </div>
          {/* <!-- /.container  --> */}
        </div>

        {/* Navbar */}

        <nav className="navbar navbar-expand-lg sticky-navbar">
          <div className="container-fluid">
            {Array.isArray(brandingData) &&
              brandingData.find((item) => item.name === "collateral_image")
                ?.content && (
                <div
                  className="navbar-brand"
                  style={{
                    textAlign: "right",
                  }}
                >
                  <img
                    src={
                      Array.isArray(brandingData) &&
                      brandingData.find(
                        (item) => item.name === "collateral_image",
                      )?.content
                        ? `data:image/png;base64,${
                            brandingData.find(
                              (item) => item.name === "collateral_image",
                            ).content
                          }`
                        : ExampleLogo
                    }
                    className="logo-dark logo-img"
                    alt="logo"
                    // width="240px"
                    height="83px"
                    style={{
                      paddingBottom: "3px",
                      paddingTop: "5px",
                      marginLeft: "30px",
                    }}
                  />
                </div>
              )}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            ></div>

            <div style={{ display: "flex" }}>
              <div className="d-none d-xl-flex" style={{ marginRight: 16 }}>
                <Box display="flex" alignItems="stretch">
                  {sessionStorage.getItem("accessToken") !== undefined &&
                  sessionStorage.getItem("accessToken") !== null ? (
                    <>
                      <Grid
                        container
                        direction="column"
                        spacing={0.5}
                        style={{ textAlign: "right" }}
                        justifyContent="center"
                      ></Grid>
                    </>
                  ) : null}
                </Box>
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <a
                  className="navbar-brand"
                  href="/main-landing"
                  onClick={(e) => {
                    e.preventDefault();
                    handleHomeClick();
                  }}
                  style={{ paddingRight: isSmallScreen ? "16px" : 0 }}
                >
                  {/* <img src="../../assets/images/logo/logo-light.png" className="logo-light" alt="logo" /> */}
                  <img
                    src={NavLogo}
                    className="logo-dark logo-img"
                    alt="logo"
                    style={{
                      paddingBottom: "3px",
                      paddingTop: "5px",
                      height: isSmallScreen ? "56px" : "83px",
                      maxWidth: "100%",
                      objectFit: "contain",
                      paddingRight: "10%",
                    }}
                  />
                </a>
              </div>
            </div>
          </div>
        </nav>
      </header>
      <QuickRegisterPatientModal
        open={openRegisterPatient}
        onClose={() => setOpenRegisterPatient(false)}
      />
    </div>
  );
}

export default Navbar;
